<script>
    import NavItem from "../components/NavItem.svelte";
</script>

<div class="py-16 flex-1 flex flex-col items-stretch justify-start gap-1">
    <div class="header-box mb-2">
        Paleo Pines
    </div>
    <div class="text-box mb-2">
        <div class="image-group my-4">
            <img src="img/paleo/gameplay1.jpg" class="image-item">
            <video autoplay muted loop class="image-item">
                <source src="img/paleo/gameplay1.mp4" type="video/mp4">
            </video>
        </div>
        I joined the project during its later stages of development, so I had to do various tasks ranging from fixing bugs to implementing new systems on top of the existing ones.
        <br><br>
        Some of my tasks include:<br>
        - Implementing UI, backend and quest systems<br>
        - Working with CSV tables and Scriptable Objects<br>
        - Fixing bugs and improving overall game performance<br>
        <br>
        Our studio encourages everyone to participate in design discussions, so I was glad to have a say. With my previous design experience, I was able to ensure that my code aligned with the design team's vision.
        <br><br>
        You can find the game's steam page <a class="link" target="_blank" rel="noopener noreferrer" href="https://store.steampowered.com/app/1202200/Paleo_Pines/">here</a>.
    </div>
    <NavItem text="back" href="/gamedev" local=true/>
</div>